import { ReplaySubject } from 'rxjs';

import {
  SelectionEvent,
  SelectionEventInitiator,
  useGridSelectedRows
} from '@/pages/ContractLines/hooks/useGridSelectionSubscription';
import { ContractLineBillingCycleOutput, VariableContractLineOutput } from '@/graphql/contracts/_generated_/contracts';

export type ContractLineSelectionPayload = {
  contractLine: ContractLineBillingCycleOutput | VariableContractLineOutput;
};

export type RefreshPayload = {
  initiator: string;
};

export const variableLinesSelectionObservable =
  new ReplaySubject<SelectionEvent<ContractLineSelectionPayload>>();

export function clearVariableLinesSelection() {
  variableLinesSelectionObservable.next({
    initiator: SelectionEventInitiator.EXTERNAL_INITIATOR,
    selectedGridRows: []
  });
}

export function useSelectedVariableLines() {
  return useGridSelectedRows(variableLinesSelectionObservable);
}

export const variableLineRefreshObservable = new ReplaySubject<RefreshPayload>();

export const triggerVariableRefresh = () => {
  variableLineRefreshObservable.next({ initiator: 'manual' });
};
